module.exports = __webpack_public_path__ + "img/ANTENNA RADIO 2 LIME.776d322.svg";